import { useI18n } from "@/i18n/LanguageContext";
import { Reveal } from "@/components/site/Reveal";
import { SectionHeading } from "@/components/site/SectionHeading";

const PersonRow = ({ name, role, label }) => (
  <div className="flex flex-col border-t border-border py-5 sm:flex-row sm:items-baseline sm:gap-6">
    {label && (
      <span className="mb-1 w-40 shrink-0 text-xs font-semibold uppercase tracking-[0.16em] text-gold-ink sm:mb-0">{label}</span>
    )}
    <div>
      <p className="font-display text-lg leading-tight text-primary">{name}</p>
      <p className="mt-0.5 text-sm leading-relaxed text-muted-foreground">{role}</p>
    </div>
  </div>
);

const Block = ({ title, children, delay }) => (
  <Reveal delay={delay}>
    <h3 className="font-display text-sm font-semibold uppercase tracking-[0.18em] text-primary/70">{title}</h3>
    <div className="mt-1">{children}</div>
  </Reveal>
);

export const Organizers = () => {
  const { t } = useI18n();
  const o = t.organizers;
  return (
    <section id="organizers" className="scroll-mt-24 bg-gradient-ivory">
      <div className="container-site section-pad py-20 md:py-24">
        <SectionHeading eyebrow={o.eyebrow} title={o.title} description={o.desc} />
        <div className="mt-12 grid gap-x-16 gap-y-12 lg:grid-cols-2">
          <Block title={o.patronsLabel} delay={0}>
            {o.patrons.map((p) => (
              <PersonRow key={p.name} name={p.name} role={p.role} />
            ))}
          </Block>
          <div className="space-y-12">
            <Block title={o.leadershipLabel} delay={0.06}>
              {o.leads.map((p) => (
                <PersonRow key={p.name} name={p.name} role={p.role} label={p.label} />
              ))}
            </Block>
            <Block title={o.teamLabel} delay={0.12}>
              {o.team.map((p) => (
                <PersonRow key={p.name} name={p.name} role={p.role} />
              ))}
            </Block>
          </div>
        </div>
      </div>
    </section>
  );
};
